<div class="policies-wrapper">
  <div class="policies-nav">
    <div class="nav-title">Contents</div>
    <ul>
      <li><a href="#overview" class="nav-link active">Overview</a></li>
      <li><a href="#licensing" class="nav-link">Licensing</a></li>
      <li><a href="#privacy" class="nav-link">Privacy Policy</a></li>
      <li class="sub-item"><a href="#data-controller" class="nav-link">Data Controller</a></li>
      <li class="sub-item"><a href="#dpo" class="nav-link">Data Protection Officer</a></li>
      <li class="sub-item"><a href="#lawful-basis" class="nav-link">Lawful Basis</a></li>
      <li class="sub-item"><a href="#data-usage" class="nav-link">Data Usage</a></li>
      <li class="sub-item"><a href="#data-access" class="nav-link">Data Access</a></li>
      <li class="sub-item"><a href="#data-transfers" class="nav-link">Data Transfers</a></li>
      <li class="sub-item"><a href="#data-retention" class="nav-link">Data Retention</a></li>
      <li class="sub-item"><a href="#your-rights" class="nav-link">Your Rights</a></li>
    </ul>
  </div>

  <div class="policies-container">
    <section id="overview">
      <h1>DOME Policies</h1>
      <p>This page outlines the key policies governing the use of the DOME Registry and its content, as well as how we handle user data.</p>
    </section>

    <section id="licensing">
      <h2>Licensing</h2>
      <p>The content submitted to and displayed by the DOME Registry, representing the curated method descriptions, is made available under an open license to promote sharing and reuse.</p>
      <p><strong>License:</strong> Creative Commons Attribution 4.0 International License (CC BY 4.0)</p>
      <p><strong>What this means:</strong> You are free to share (copy and redistribute the material in any medium or format) and adapt (remix, transform, and build upon the material) for any purpose, even commercially, as long as you give appropriate credit (attribution) to the original creators and the DOME Registry, provide a link to the license, and indicate if changes were made.</p>
      <p><strong>Full License Details:</strong> <img class="mx-2" src="../../assets/licence.png" alt="CC BY 4.0 license logo"> <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank">View the CC BY 4.0 License Deed</a>   </p>
    </section>

    <section id="privacy">
      <h2>Privacy Policy</h2>
      <p>This privacy notice explains what personal data is collected when you interact with the DOME Registry, for what purposes, how it is processed, and how we keep it secure, in compliance with applicable data protection regulations (including GDPR).</p>
    </section>

    <section id="data-controller">
      <h3>Who Controls Your Personal Data (Data Controller)?</h3>
      <p>Professor Silvio Tosatto<br>
      University of Padua, Department of Biomedical Sciences<br>
      Viale G. Colombo 3, 35131 Padua, Italy<br>
      Phone: +39 049 827 6269<br>
      Email: contact&#64;dome-ml.org</p>
    </section>

    <section id="dpo">
      <h3>Data Protection Officer (DPO)</h3>
      <p>Director of the Department of Biomedical Sciences, University of Padua<br>
      University of Padua, Department of Biomedical Sciences<br>
      Viale G. Colombo 3, 35131 Padua, Italy<br>
      Phone: +39 049 827 6047<br>
      Email: privacy&#64;unipd.it (or link to Uni Padua's central privacy contact page)</p>
    </section>

    <section id="lawful-basis">
      <h3>What is our lawful basis for processing your personal data?</h3>
      <p>Processing your personal data is necessary for our legitimate interest of allowing the day-to-day management, operation and functioning of DOME Registry.</p>
    </section>

    <section id="data-usage">
      <h3>How will your personal data be used</h3>
      <p>We will use the personal data to:</p>
      <ul>
        <li>Provide user access to the service</li>
        <li>Create anonymous usage statistics</li>
      </ul>
    </section>

    <section id="data-access">
      <h3>Who will have access to your personal data?</h3>
      <p>The personal data will be disclosed to authorized DOME registry staff.</p>
    </section>

    <section id="data-transfers">
      <h3>Will your personal data be transferred to third countries (i.e. countries not part of EU/EAA) and/or international organisations?</h3>
      <p>Personal data is transferred to the following service provider based in a third country which the DOME Registry relies on to provide the service:</p>
      <ul>
        <li>Google Analytics</li>
      </ul>
      <p>There are no personal data transfers to international organisations.</p>
    </section>

    <section id="data-retention">
      <h3>How long do we keep your personal data?</h3>
      <p>Any personal data directly obtained from you will be retained as long as the service is live, even if you stop using the service.</p>
      <p>We will keep the personal data for the minimum amount of time possible to ensure legal compliance and to facilitate internal and external audits if they arise.</p>
      <p>Access to the web and security logs containing personal data are restricted to relevant DOME Registry staff.</p>
    </section>

    <section id="your-rights">
      <h3>Your rights regarding your personal data</h3>
      <p>You have the right to</p>
      <ol>
        <li>Not be subject to decisions based solely on an automated processing of data (i.e. without human intervention) without you having your views taken into consideration.</li>
        <li>Request at reasonable intervals and without excessive delay or expense, information about the personal data processed about you. Under your request we will inform you in writing about, for example, the origin of the personal data or the preservation period.</li>
        <li>Request information to understand data processing activities when the results of these activities are applied to you.</li>
        <li>Object at any time to the processing of your personal data unless we can demonstrate that we have legitimate reasons to process your personal data.</li>
        <li>Request free of charge and without excessive delay rectification or erasure of your personal data. It must be clarified that rights 4 and 5 are only available whenever the processing of your personal data is not necessary to:
          <ul>
            <li>Comply with a legal obligation.</li>
            <li>Perform a task carried out in the public interest.</li>
            <li>Exercise authority as a data controller.</li>
            <li>Archive for purposes in the public interest, or for historical research purposes, or for statistical purposes.</li>
            <li>Establish, exercise or defend legal claims.</li>
          </ul>
        </li>
      </ol>
    </section>
  </div>
</div>
<app-big-footer></app-big-footer>
